import { request } from '../../request';

export async function publishShifts(shiftIds: string[]) {
  return request.post<void>(`/v2/shifts/publish`, shiftIds);
}
